import React from "react";
import { RegistrationCancellationReportUIProvider } from "./RegistrationCancellationReportUIContext";
import { RegistrationCancellationReportCard } from "./RegistrationCancellationReportCard";

export function RegistrationCancellationReportPage() {
 return (
    <RegistrationCancellationReportUIProvider>
      <RegistrationCancellationReportCard />
    </RegistrationCancellationReportUIProvider>
  );
}